import { createApp } from 'vue'
import { createPinia } from 'pinia'

import CreateDocumentForm from '@/src/javascripts/document/CreateDocumentForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const newDocumentForm = document.querySelector('#new-document-form')

  if (newDocumentForm && !newDocumentForm.__vue_app__) {
    const pinia = createPinia()
    const app = createApp({
      components: { CreateDocumentForm, BaseAlert }
    })

    app.use(pinia)
    app.mount(newDocumentForm)
  }
})
